import { type InAppNotificationType } from "@doitintl/cmp-models";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import texts from "../texts";

export const cyIds = {
  label: (type: InAppNotificationType) => `in-app-notification-settings-label-${type.toLowerCase().replace(" ", "-")}`,
  option: (type: InAppNotificationType) =>
    `in-app-notification-settings-option-${type.toLowerCase().replace(" ", "-")}`,
};

type InAppNotificationOptionProps = {
  type: InAppNotificationType;
  checked: boolean;
  onChange: (type: InAppNotificationType, checked: boolean) => void;
};

function InAppNotificationOption({ type, checked, onChange }: InAppNotificationOptionProps) {
  return (
    <FormControlLabel
      data-cy={cyIds.label(type)}
      control={
        <Checkbox
          data-cy={cyIds.option(type)}
          checked={checked}
          onChange={(e) => {
            onChange(type, e.target.checked);
          }}
        />
      }
      label={texts.settings.selection.options(type)}
    />
  );
}

export default InAppNotificationOption;
